module.exports = __webpack_public_path__ + "img/midend.055fc84b.png";